import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {useModalChat} from "@dropDesk/presentation/pages/chat/ui/modals/visible_modal_search";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {BackendAction} from "@dropDesk/domain/entities/common/actions_entity";
import ModalSearchUser from "@dropDesk/presentation/components/modals/modal_search_user";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";

const ModalInternalChatLinkedUsers = observer(
    ({
         internalChatUsersEligible,
         internalChatUsersDefault,
         internalChat,
         onChangeUsersLinked,
         onDeleteUsersLinked,
         onSaveEditUsers
     }: {
        internalChatUsersEligible: InternalChatUserEntity[]
        internalChatUsersDefault: InternalChatUserEntity[]
        internalChat: InternalChatEntity
        onChangeUsersLinked: (user: UserEntity) => void,
        onDeleteUsersLinked: (id: string) => void,
        onSaveEditUsers?: () => Promise<void>
    }) => {

        const getInternalChatUserDeleted = (selectedRows: UserEntity[], internalChatUsers: InternalChatUserEntity[]) =>
            internalChatUsers.filter(internalChatUsers => selectedRows.map(user => user.id)
                .indexOf(internalChatUsers.idUser) === -1 && internalChatUsers.action !== BackendAction.delete);

        const getEligibleUsers = (selectedRows: UserEntity[], internalChatUsers: InternalChatUserEntity[]) =>
            selectedRows.filter(sector => internalChatUsers.filter(internalChatUser => internalChatUser.action !== BackendAction.delete)
                .map(internalChatUser => internalChatUser.idUser).indexOf(sector.id) === -1);

        const setUsersDeleteInBatch = (internalChatUsers: InternalChatUserEntity[]): void => {
            for (let iteratorExclude = 0; iteratorExclude < internalChatUsers.length; iteratorExclude++) {
                onDeleteUsersLinked(internalChatUsers[iteratorExclude].idUser);
            }
        }

        const setUsersInBatch = (users: UserEntity[]): void => {
            for (let iteratorInclude = 0; iteratorInclude < users.length; iteratorInclude++) {
                onChangeUsersLinked(users[iteratorInclude]);
            }
        }

        const restoreSectorsUsersDefault = (): void => {

            for (let i = 0; i < internalChatUsersDefault.length; i++) {
                onChangeUsersLinked(internalChatUsersDefault[i].user!);
            }

            const ineligibleUsers: InternalChatUserEntity[] = internalChatUsersEligible.filter(sectorUsers => !internalChatUsersDefault.some(_internalChatUsers => sectorUsers.idUser === _internalChatUsers.idUser));
            setUsersDeleteInBatch(ineligibleUsers);
        }


        const rowSelectionInternalChatUsers = {
            selectedRowKeys: internalChatUsersEligible.map(entry => entry.idUser),
            onChange: (selectedRowKeys: React.Key[], selectedRows: UserEntity[]) => {

                const tempSelectedRows = selectedRows.concat(internalChatUsersEligible.map(entry => entry.user!)).filter(item => item != undefined);
                const totalSelectedRows = selectedRowKeys.map(key => tempSelectedRows.filter(item => item.id == key)[0]);

                const users = internalChat?.users ?? [];
                const internalChatUserDeleted = getInternalChatUserDeleted(totalSelectedRows, users);
                const sectorsAdd = getEligibleUsers(totalSelectedRows, users);
                setUsersDeleteInBatch(internalChatUserDeleted);
                setUsersInBatch(sectorsAdd)

            },
            getCheckboxProps: (record: SectorEntity) => ({
                disabled: false,
            }),
            preserveSelectedRowKeys: true
        };

        const {
            visibleModalSearchUsers,
            setVisibleModalSearchUsers
        } = useBetween(useModalChat);

        return (
            <>
                {visibleModalSearchUsers && <ModalSearchUser
                    visible={visibleModalSearchUsers}
                    onClose={() => {
                        restoreSectorsUsersDefault();
                        setVisibleModalSearchUsers(false);
                    }}
                    onSave={() => {
                        if (onSaveEditUsers) {
                            onSaveEditUsers();
                        }
                        setVisibleModalSearchUsers(false);
                    }}
                    role={UserRole.attendant}
                    useFooter={true}
                    handleSelectUser={(user: UserEntity) => {
                        const hasSelected: boolean = internalChat!.users!.filter((entry) => entry.idUser === user.id && entry.action !== BackendAction.delete).length > 0;
                        if (hasSelected) {
                            onDeleteUsersLinked(user.id);
                        } else {
                            onChangeUsersLinked(user)
                        }
                    }}
                    textHeaderModal={"Pesquisa de atendentes"}
                    labelNoResults={"Nenhum atendente encontrado na pesquisa"}
                    inputSearchPlaceholder={"Pesquise por atendentes"}
                    rowSelection={rowSelectionInternalChatUsers}
                />}
            </>
        )
    })
export default ModalInternalChatLinkedUsers;
